import React from 'react';
import { useDispatch } from 'react-redux';
import { DatePicker } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import styled from 'styled-components';
import { theme } from 'styles/theme';
import { Flex, Text, Button } from 'atoms';
import { leaveFilter } from 'store/leaveSlice';

const DateRange = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	position: absolute;
	z-index: 1;
	min-width: 330px;
	min-height: 200px;
	margin-left: 30px;
	padding: 5px 10px;
	background-color: white;
	color: ${(props) => props.theme.colors.black};
`;

const Clear = styled.button`
	margin-left: 280px;
	border: 0;
	background-color: white;
	:focus {
		outline: none;
	}
`;

export default function DateRangeModal({ visible, hide }) {
	const dispatch = useDispatch();
	const dates = [];

	function onChange(date) {
		const formatDate = moment(date).format('YYYY-MM-DD');

		dates.push(formatDate);
	}

	return (
		<DateRange visible={visible}>
			<Clear onClick={() => hide()}>&times;</Clear>
			<Flex padding="10px" mb="10px">
				<Text fontSize="8px" p="10px 0" mr="20px">
					From:
				</Text>
				<DatePicker
					size="small"
					placeholder="DD/MM/YY"
					style={{
						width: '230px',
						backgroundColor: theme.colors.Platinum,
						color: theme.colors.black,
						font: '10px',
					}}
					format="DD/MM/YYYY"
					onChange={(date) => onChange(date)}
				/>
			</Flex>
			<Flex padding="10px" mb="10px">
				<Text fontSize="8px" p="10px 0" mr="30px">
					To:
				</Text>
				<DatePicker
					size="small"
					placeholder="DD/MM/YY"
					style={{
						width: '230px',
						backgroundColor: theme.colors.Platinum,
						color: theme.colors.black,
						font: '10px',
					}}
					format="DD/MM/YYYY"
					onChange={(date) => onChange(date)}
				/>
			</Flex>
			<Button
				width="300px"
				mt="10px"
				fontSize="10px"
				textAlign="center"
				onClick={() => {
					dispatch(leaveFilter(dates));
					hide();
				}}
			>
				Apply
			</Button>
		</DateRange>
	);
}
DateRangeModal.propTypes = {
	visible: PropTypes.bool,
	hide: PropTypes.func,
};
